module.exports = __webpack_public_path__ + "static/media/Gallery-18.f7403097.jpg";